/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: colorPresets.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Color presets for Appearance module.

 🔁 Last Updated: 2025-01-XX by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import type { ColorPreset } from '../types';

/**
 * Color presets for quick selection
 */
export const colorPresets: ColorPreset[] = [
  { name: 'Blue', primary: '#3B82F6', secondary: '#64748B' },
  { name: 'Green', primary: '#10B981', secondary: '#6B7280' },
  { name: 'Purple', primary: '#8B5CF6', secondary: '#6B7280' },
  { name: 'Red', primary: '#EF4444', secondary: '#6B7280' },
  { name: 'Orange', primary: '#F59E0B', secondary: '#6B7280' }
];

